module.exports = __webpack_public_path__ + "static/media/map-min.55b19fc7.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/devdata/resources/map-min.png
// module id = 520
// module chunks = 0